import React from 'react'
import './Loader.css'
const Loading = () => {
    return (
        <div className="flex justify-center min-h-[90vh] items-center">
            <div className="spinner"></div>
        </div>


    )
}

export default Loading